// item 1599 (Chad: "put in the ledger under all subscription areas a First enrolled Date OR
// Contract Enrollment Billing Start Date") — the ONE rule for a subscription's ENROLLED date,
// shared by every subscription ledger: the EARLIER of Stripe's own start_date (when the customer
// was first enrolled) and the schedule's Basix start date (the contract's billing start). An
// adopted (imported) sub's Basix start is the IMPORT day, so Stripe's date wins there; a Basix
// sub with no Stripe read (Stripe down, manual schedule) falls back to its Basix start.

export interface EnrolledDate {
  date: string; // "yyyy-mm-dd", the LOCAL calendar day
  source: 'stripe' | 'basix';
}

// "2024-09-20T00:00:00Z" (UTC instant) → the local calendar day; a zone-less SQL datetime
// ("2026-10-15T00:00:00") is already a calendar day and is read as-is
const dayOf = (value?: string | null): string | null => {
  if (!value) return null;
  const v = value.trim();
  if (!v) return null;
  if (/[zZ]$|[+-]\d\d:?\d\d$/.test(v)) {
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
  }
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(v);
  return m ? m[1] : null;
};

export function enrolledDate(basixStart?: string | null, stripeStart?: string | null): EnrolledDate | null {
  const s = dayOf(stripeStart);
  const b = dayOf(basixStart);
  if (s && (!b || s <= b)) return { date: s, source: 'stripe' };
  if (b) return { date: b, source: 'basix' };
  return null;
}

// "9/20/2024"
export const enrolledDisplay = (e: EnrolledDate | null): string => {
  if (!e) return '—';
  const [y, m, d] = e.date.split('-');
  return `${Number(m)}/${Number(d)}/${y}`;
};

export const enrolledTitle = (e: EnrolledDate | null): string => {
  if (!e) return 'No enrollment date on file';
  return e.source === 'stripe'
    ? 'First enrolled — the Stripe subscription\'s start date'
    : 'Contract billing start — the subscription\'s start date in Basix';
};
